module.exports = __webpack_public_path__ + "static/media/pp-bg6.4c68f902.png";